<!-- src/lib/components/LabelChip.svelte -->
<!--
  Linear-style dot-prefix label chip. A single colored dot followed
  by the label text in the label's hue. Much lighter visual weight
  than our previous filled-pill approach — the board stays readable
  with 3+ chips per card.

  The label color is assumed to be an oklch() or hex string. We
  hydrate the chip with low-opacity background + border + dot so the
  chip reads as "tinted" rather than "filled".
-->
<script lang="ts">
  interface Props {
    name:  string;
    color: string;
    /** Optional compact mode: dot only, no text. Used on hover for multi-chip overflow. */
    compact?: boolean;
  }
  let { name, color, compact = false }: Props = $props();
</script>

<span
  class="label-chip"
  class:compact
  style="--label-color: {color};"
  title={name}
>
  <span class="dot" aria-hidden="true"></span>
  {#if !compact}
    <span class="name">{name}</span>
  {/if}
</span>

<style>
  .label-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.1rem 0.45rem 0.1rem 0.4rem;
    font-size: 0.65rem;
    font-weight: 500;
    line-height: 1;
    color: var(--label-color);
    background: color-mix(in oklch, var(--label-color) 10%, transparent);
    border: 1px solid color-mix(in oklch, var(--label-color) 30%, transparent);
    border-radius: 4px;
    white-space: nowrap;
    letter-spacing: 0.01em;
  }
  .label-chip.compact {
    padding: 0.18rem;
    width: 12px;
    height: 12px;
    justify-content: center;
    gap: 0;
  }
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--label-color);
    flex-shrink: 0;
  }
  .name {
    max-width: 10ch;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
